/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  AppointmentColor,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    AppointmentColorFromJSON,
    AppointmentColorToJSON,
} from '../models/index';

/**
 * 
 */
export class AppointmentColorApi extends runtime.BaseAPI {

    /**
     * Lists all active appointment colors
     */
    async listAppointmentColorsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentColor>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/appointment-colors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentColorFromJSON));
    }

    /**
     * Lists all active appointment colors
     */
    async listAppointmentColors(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentColor>> {
        const response = await this.listAppointmentColorsRaw(initOverrides);
        return await response.value();
    }

}
